import { atom } from "recoil";

export const addStateEmployeeStatus = atom({
  key: "addStateEmployeeStatus",
  default: false,
});
export const editStateEmployeeStatus = atom({
  key: "editStateEmployeeStatus",
  default: false,
});
export const rowEditIdStateEmployeeStatus = atom({
  key: "rowEditIdStateEmployeeStatus",
  default: null,
});
export const disableButtonStateEmployeeStatus = atom({
  key: "disableButtonStateEmployeeStatus",
  default: false,
});

export const selectedRowsStateEmployeeStatus = atom({
  key: "selectedRowsStateEmployeeStatus",
  default: [],
});

export const setFilterTextEmployeeStatus = atom({
  key: "setFilterTextEmployeeStatus",
  default: "",
});
